import SelfAssesmentSvelte from './SelfAssessment.svelte'

export default class SelfAssessment extends BaseView {
    initialize() {
        this.setElement('<div></div>')
        this.addSvelteChildView(this.el, SelfAssesmentSvelte, {
            model: this.model
        })
    }
}
